import RoutesConstants from '../../shared-components/Routes/routes.constants';
import { useNavigate, useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react'
// import PaymentCard from './PaymentCard';
import { observer } from 'mobx-react';
import PaymentPage from './PaymentPage';
import { ProductType } from '../../constants/enum';
import { useStore } from '../../contexts/StoreProvider';

const TrainerRechargePayment = () => {
    const { rechargeType } = useParams();
    const navigate = useNavigate();
     const { adminStore } = useStore();
     const {allPaymentSettingInfo } = adminStore;
    const [rechargeAmount, setRechargeAmount] = useState<number>(0);
    useEffect(() => {
        if (rechargeType && (parseInt(rechargeType) != ProductType.TrainerRecharge10 
            && parseInt(rechargeType) != ProductType.TrainerRecharge25
            && parseInt(rechargeType) != ProductType.TrainerRecharge50
            && parseInt(rechargeType) != ProductType.TrainerRecharge100
            && parseInt(rechargeType) != ProductType.TrainerRecharge150
            && parseInt(rechargeType) != ProductType.TrainerRecharge200
            && parseInt(rechargeType) != ProductType.TrainerRecharge300
            && parseInt(rechargeType) != ProductType.TrainerRecharge500
            && parseInt(rechargeType) != ProductType.TrainerRecharge800
            && parseInt(rechargeType) != ProductType.TrainerRecharge1000))
        {
            navigate(RoutesConstants.Dashboard);
        }
    }, [rechargeType])

    const getRechargeAmount = () => {
        if (!rechargeType || allPaymentSettingInfo.length === 0) return undefined;

        const type = parseInt(rechargeType);
        const setting = allPaymentSettingInfo.find(
            s => s.ProductType === type
        );
        if (!setting) return undefined;
        return setting.JPY;
    };
    // -------------------------------------------------------------------

    const amount = getRechargeAmount();

    if (!amount) return null;

    return(
        <>
            <PaymentPage productType={rechargeType} amount={getRechargeAmount()}/>
        </>
    ) 
}
export default observer(TrainerRechargePayment);